import { useCallback, useEffect, useState } from "react";
import "./App.css";
import A from "./sounds/A.mp3";
import B from "./sounds/B.mp3";
import C from "./sounds/C.mp3";
import D from "./sounds/D.mp3";
import E from "./sounds/E.mp3";
import F from "./sounds/F.mp3";
import G from "./sounds/G.mp3";
import Click from "./sounds/Click.mp3";

function App() {
  const [click] = useState(new Audio(Click));
  const [audioMap] = useState({
    A: new Audio(A),
    B: new Audio(B),
    C: new Audio(C),
    D: new Audio(D),
    E: new Audio(E),
    F: new Audio(F),
    G: new Audio(G),
  });

  const [notes, setNotes] = useState(["A", "B", "C", "D", "E", "F", "G"]);
  const [bpm, setBpm] = useState(60);
  const [activeIndex, setActiveIndex] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const [continuous, setContinuous] = useState(false);
  const [countIn, setCountIn] = useState(true);
  const [countInPlaying, setCountInPlaying] = useState(true);
  const [countInCounter, setCountInCounter] = useState(0);

  const oneMinuteInMs = 3600;
  const bpmInMs = bpm * 60;

  const [noteDuration, setNoteDuration] = useState(
    (oneMinuteInMs / bpmInMs) * 1000
  );

  const shuffleNotes = useCallback(() => {
    let currentIndex = notes.length,
      randomIndex;
    const arr = [...notes];

    // While there remain elements to shuffle.
    while (currentIndex !== 0) {
      // Pick a remaining element.
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex--;

      // And swap it with the current element.
      [arr[currentIndex], arr[randomIndex]] = [
        arr[randomIndex],
        arr[currentIndex],
      ];
    }

    setNotes(arr);
    setActiveIndex(0);
  }, [notes]);

  // const playCountIn = useCallback(() => {
  //   console.log("hmmm...");
  //   setCountInPlaying(true);
  //   let counter = 1;
  //   click.play();

  //   const timeoutId = setTimeout(() => {
  //     for (let i = counter; i <= 4; i++) {
  //       click.play();
  //       if (i >= 4) {
  //         clearTimeout(timeoutId);
  //         setCountInPlaying(false);
  //         // setActiveIndex(0);
  //       }
  //     }
  //   }, noteDuration);
  // }, [click, noteDuration]);

  const playNote = useCallback(() => {
    console.log("countInPlaying", countInPlaying);
    console.log("isPlaying", isPlaying);
    console.log("countInCounter", countInCounter);
    if (countInPlaying) {
      click.play();

      setTimeout(() => {
        click.pause();
        click.currentTime = 0;
      }, 200);

      if (countInCounter >= 3) {
        setCountInPlaying(false);
        setCountInCounter(0);
      }
      setCountInCounter(countInCounter + 1);
    } else if (isPlaying && !countInPlaying) {
      const currentNote = audioMap[notes[activeIndex]];
      currentNote.play();
      click.play();

      setTimeout(() => {
        currentNote.pause();
        currentNote.currentTime = 0;
      }, noteDuration);

      setTimeout(() => {
        click.pause();
        click.currentTime = 0;
      }, 200);
    }
  }, [
    activeIndex,
    audioMap,
    click,
    countInCounter,
    countInPlaying,
    isPlaying,
    notes,
    noteDuration,
  ]);

  const incrementActiveIndex = useCallback(() => {
    if (isPlaying && !countInPlaying) {
      const newActiveIndex = (activeIndex + 1) % notes.length;
      setActiveIndex(newActiveIndex);

      if (continuous && newActiveIndex === 0) {
        shuffleNotes();
      }
    }
  }, [
    activeIndex,
    continuous,
    countInPlaying,
    notes.length,
    isPlaying,
    shuffleNotes,
  ]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (isPlaying && !countInPlaying) {
        incrementActiveIndex();
      } else {
        clearInterval(intervalId);
      }
    }, noteDuration);

    return () => {
      clearInterval(intervalId);
    };
  }, [countInPlaying, incrementActiveIndex, bpm, isPlaying, noteDuration]);

  // play note once the activeIndex has been updated
  useEffect(() => {
    if (isPlaying) {
      playNote();
    }
  }, [activeIndex, countInCounter, isPlaying, playNote]);

  useEffect(() => {
    setNoteDuration((oneMinuteInMs / bpmInMs) * 1000);
  }, [bpm, bpmInMs]);

  const incrementBpm = () => {
    setBpm(bpm + 10);
  };

  const decrementBpm = () => {
    setBpm(bpm - 10);
  };

  return (
    <div className="App">
      <div className="container">
        <h1>Note Scrambler</h1>
        <div className="row">
          <label>
            Continuous Mode
            <input
              onChange={() => {
                setContinuous(!continuous);
                setActiveIndex(0);
              }}
              type="checkbox"
              checked={continuous}
            />
          </label>
          <label style={{ marginLeft: "15px" }}>
            Count In
            <input
              onChange={() => {
                setCountIn(!countIn);
                setCountInPlaying(!countInPlaying);
              }}
              type="checkbox"
              checked={countIn}
            />
          </label>
        </div>

        <div className="row">
          BPM: {bpm}&nbsp;
          <button onClick={incrementBpm}>+</button>
          <button onClick={decrementBpm}>-</button>
          <button style={{ marginLeft: "20px" }} onClick={shuffleNotes}>
            Shuffle Notes
          </button>
        </div>
        <div className="row">
          <button
            onClick={() => {
              // don't want to play note again when clicking stop
              if (!isPlaying) {
                // if (countIn) setCountInPlaying(true);
                playNote();
              }
              setIsPlaying(!isPlaying);
            }}
          >
            {isPlaying ? "Stop" : "Start"}
          </button>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "20px",
            alignItems: "center",
          }}
        >
          {notes.map((note, index) => (
            <div
              className={activeIndex === index ? "active" : "inactive"}
              key={note}
            >
              {note}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default App;
